import s from './MessageTemplates.css';

export const MessageTemplates = ({ children }: { children: JSX.Element }): JSX.Element => {
    return (
        <div className={s.pageContainer}>
            <div className={s.messageTemplatesContainer}>{children}</div>
        </div>
    );
};
